<template>
  <div>
    <NBar title="卡项列表" :top="true"/>
    <nut-row v-for="(item,index) in list" :key="index" class='item'>
      <div class='content'>
        <div class='title'>
          <span class='name'>{{item.name}}</span>
        </div>
        <div class='edit'>
          <div class='btn-groups'>
            <div class='div-btn' @click='goCard(item)'>
              <img :src='listIcon.address_icon_edit'/>
              <span>编辑</span>
            </div>
            <div class='div-btn' @click='delTap(item)'>
              <img :src='listIcon.address_icon_delect'/>
              <span>删除</span>
            </div>
          </div>
        </div>
      </div>
    </nut-row>
    <nut-dialog title="提示" :visible="dialogShow" @ok-btn-click="del()" @cancel-btn-click="dialogShow=false"
                @close="dialogShow=false">
      <span>是否删除该卡项?</span>
    </nut-dialog>
    <div v-if="bottom" class="bottom">
      <nut-button style="margin: 0 15px;border-radius: 5px;width:92%;" @click="goCard()">添加一个卡项</nut-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  data () {
    return {
      list: [],
      listIcon: {
        address_icon_edit: require('@/resource/img/device/address_icon_edit.png'),
        address_icon_delect: require('@/resource/img/device/address_icon_delect.png'),
      },
      dialogShow: false,
      bottom : false
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/device/api/device/device-card/list',
      }).then(res => {
        this.list = res.data
        if(this.list.length <= 0){
          this.bottom = true
        }
      })
    },
    goCard (item) {
      this.$router.push({
        path: '/device/CardSet',
        query: {
          data: encodeURIComponent(JSON.stringify(item))
        }
      })
    },
    delTap (item) {
      this.id = item.id
      this.dialogShow = true
    },
    del () {
      this.$api.delete({
        url: '/device/api/device/device-card/delete',
        id: this.id
      }).then(() => {
        this.getData()
        this.dialogShow = false
      })
    },
  }
}
</script>

<style scoped>
  .item {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    background-color: #fff;
  }

  .item .content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    height: 55px;
    line-height: 55px;
  }

  .item .content .title {
    margin: 0 12px;
    display: flex;
    align-items: center;
  }

  .item .content .title .name {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
  }

  .item .edit {
    background: #fff;
    margin-top: 1px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item .edit .def img {
    width: 13px;
    height: 13px;
  }

  .item .edit .btn-groups {
    display: flex;
    align-items: center;
    margin-right: 12px;
  }

  .item .edit .btn-groups .div-btn {
    display: flex;
    align-items: center;
    margin-left: 15px;
  }

  .item .edit .btn-groups .div-btn img {
    width: 13px;
    height: 13px;
  }

  .item .edit .btn-groups .div-btn span {
    margin-left: 5px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(74, 74, 74, 1);
  }

  /* 底部 */
  .bottom {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 15px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    background-color: #ffffff;
  }

  >>> .nut-button {
    background: #409EFF;
  }

  >>> .nut-dialog-ok {
    background: #409EFF;
    border-top: 1px solid #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/Card.vue